<template>
  <v-container fluid class="fill-height">
    <v-card class="fill-height idcs-fill-width idcs-main-list back-img">
      <v-card-title>
        <i18n path="title.history" class="text-h4 text-uppercase text-decoration-underline"></i18n>
        <v-spacer></v-spacer>
        <span class="mr-4">
          <DateRange v-model="dates" />
        </span>
        <span>
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="search" clearable :label="$t('label.search')"></v-text-field>
        </span>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :items="filteredItems"
          :headers="headers"
          :search="search"
          class="idcs-main-list transparent"
          :footer-props="foot_props"
          :no-data-text="$t('label.nodata')"
        >
          <template
            v-slot:item.recipients="{item}"
          >{{item.recipients.items?item.recipients.items.length:0}}</template>
          <template v-slot:item.action="{item}">
            <v-btn icon :to="'/taskh/'+item.idx" color="primary">
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.created="{item}">{{item.created|dt-time}}</template>
          <template v-slot:item.price="{item}">{{item.price|currency}}</template>
          <template v-slot:item.planed="{item}">{{item.planed|dt-time}}</template>
          <template v-slot:item.ended="{item}">{{item.ended|dt-time}}</template>
          <template v-slot:item.status="{item}">{{$t('status._'+item.status)}}</template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";
import DateRange from "@/components/DateRange.vue";

export default {
  name: "TasksArchive",
  components: { DateRange },
  mixins: [commonmixin],
  data() {
    return {
      headers: [
        { text: this.$t("fields.action"), value: "action", sortable: false },
        { text: this.$t("fields.pos"), value: "pos" },
        { text: this.$t("fields.name"), value: "name" },
        { text: this.$t("fields.list"), value: "list" },
        {
          text: this.$t("fields.recipients"),
          value: "recipients",
          align: "center"
        },
        { text: this.$t("fields.status"), value: "status" },
        { text: this.$t("fields.scheduled"), value: "planed" },
        { text: this.$t("fields.ended"), value: "ended" },
        { text: this.$t("fields.count"), value: "msgcount", align: "center" },
        { text: this.$t("fields.price"), value: "price", align: "right" }
      ]
    };
  },
  methods: {
    loadData() {
      this.$api.getTasksArchived().then(response => {
        this.items = response;
      });
    }
  },
  mounted() {
    this.filterBy = "planed";
    this.loadData();
  }
};
</script>

<style scoped>
.back-img {
  background-image: url("../../public/img/sms_group_random.svg");
  background-size: 450px;
  background-repeat: initial;
}
</style>